export const errorRouteNames = {
  ERROR: 'error',
  SERVICE_ERROR: 'error.serviceError',
  NOT_FOUND: 'error.notFound',
  APPLICATION_ERROR: 'error.applicationError',
};

export const errorRouteDefs = [
  {
    name: errorRouteNames.ERROR,
    path: '/error',
  },
  {
    name: errorRouteNames.NOT_FOUND,
    path: '/not-found',
  },
  {
    name: errorRouteNames.APPLICATION_ERROR,
    path: '/application-error',
  },
  {
    name: errorRouteNames.SERVICE_ERROR,
    path: '/service-error',
  },
];

export const errorRouteModules = {
  [errorRouteNames.ERROR]: import('./ErrorPage'),
  [errorRouteNames.NOT_FOUND]: import('./NotFoundPage'),
};
